import OnboardingRoutesWithProvider from '@leagueplatform/onboarding';
import { Box, styled } from '@leagueplatform/genesis-core';
import { TENANT_ID } from 'common/constants';
import {
  getAmplarFeatureHighlightsContentfulId,
  getMyHealthFeatureHighlightsContentfulId,
} from 'common/env';
import { usePPSystemId } from 'hooks/use-pp-system-id/use-pp-system-id.hook';
import { PATIENT_PORTAL_SYSTEM_IDS } from 'types/patient-portal-system.types';

const FeatureHighlightWrapper = styled(Box, {
  '& .GDS-button': {
    paddingBlock: '4px',
    paddingInline: '12px',

    // Set buttons styles to secondary priority
    typography: '$buttonTwo',
    color: '$secondaryTextDefault',
    backgroundColor: '$secondaryBackgroundDefault',
    borderColor: '$secondaryBorderDefault',
    '&:hover': {
      color: '$secondaryTextHovered',
      backgroundColor: '$secondaryBackgroundHovered',
      borderColor: '$secondaryBorderHovered',
    },
  },
});

export const OnboardingFeatureHighlights = ({
  onFeatureHighlightsComplete,
}: {
  onFeatureHighlightsComplete: (error?: Error) => void;
}) => {
  const systemId = usePPSystemId();
  const getFeatureHighlightsContentfulId =
    systemId === PATIENT_PORTAL_SYSTEM_IDS.AMPLAR
      ? getAmplarFeatureHighlightsContentfulId
      : getMyHealthFeatureHighlightsContentfulId;

  return (
    <FeatureHighlightWrapper>
      <OnboardingRoutesWithProvider
        contentfulId={getFeatureHighlightsContentfulId()}
        tenantId={TENANT_ID}
        onOnboardingComplete={onFeatureHighlightsComplete}
      />
    </FeatureHighlightWrapper>
  );
};
